<template>
    <div>
        <b-modal size="md"
                 v-model="modalShow"
                 :title="`${this.$locale.patient}削除`"
                 ok-title="削除"
                 ok-variant="yokumiru-orange"
                 cancel-title="キャンセル"
                 cancel-variant="yokumiru-gray"
                 @ok="deleteUser">
            <div v-if="user">
                <div class="modal-body">
                    <div class="jumbotron pt-3 pb-3">
                        <div>{{ $locale.patient }}番号：{{ user.id }}</div>
                        <div>名前：{{ user.full_name }} （ {{ user.full_name_kana }} ）</div>
                        <div>年齢：{{ user.age }}</div>
                        <div v-if="user.is_company">法人名：{{ user.groups[0].name }}</div>
                    </div>
                    <p class="text-center">上記の{{ $locale.patient }}を削除します。よろしいですか？</p>

                    <!-- @todo issue/371 担当者を削除可能にする場合は復帰 -->
                    <!-- <p -->
                    <!--     v-if="user.is_company && isAuthorizer" -->
                    <!--     class="text-center text-danger font-weight-bold"> -->
                    <!--     この{{ $locale.patient }}は法人の担当者に設定されています。<br>{{ $locale.patient }}を削除すると担当者は未設定の状態になります。 -->
                    <!-- </p> -->
                </div>
            </div>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button class="btn btn-yokumiru-orange float-right" @click="deleteUser">削除</button>
                <button class="btn btn-yokumiru-gray float-right mr-2" @click="close">キャンセル</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        name: 'DeleteUserModal',

        data: function () {
            return {
                inProgress :false,
                modalShow: false,
                user: null,
                errors: {},
            }
        },

        computed: {
            /**
             * 担当者判定
             *
             * @return {boolean}
             */
            isAuthorizer: function () {
                if (!this.user || !this.user.groups) {
                    return false
                }

                return !!this.user.groups.find((group) => group.authorizer_id === this.user.id)
            },
        },

        created: function () {
            bus.$on('open-modal-delete-user', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-delete-user')
        },

        methods: {
            open: function (data) {
                this.modalShow = true
                this.user = data
            },

            close: function () {
                this.modalShow = false
            },

            deleteUser: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.put(`${constants.admin.users.endpoint.base}/${this.user.id}/delete`)
                    .then(() => {
                        bus.$emit('fetch-users')
                        bus.$emit('alert-success', `${this.$locale.patient}を削除しました。`)
                        this.errors = {}
                        this.close()
                    } )
                    .catch(({response}) => {
                        if (response.data.hasOwnProperty('errors') &&
                            response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    } )

                this.inProgress = false
            },
        },
    }
</script>

<style scoped>

</style>
